import { useQuery } from '@tanstack/react-query';
import { getDeductionTargetPeriod } from '../api/deductionsAdminApi';

interface UseDeductionTargetPeriodArgs {
  /** ISO date (yyyy-MM-dd). Null skips the lookup. */
  date: string | null;
  gangId?: string | null;
  targetWorkerId?: string | null;
}

/**
 * Which pot period a deduction date lands in, and whether that pot still takes one.
 * Without a gang or worker the answer is the period only — no pot to check yet.
 */
export function useDeductionTargetPeriod({
  date,
  gangId,
  targetWorkerId,
}: UseDeductionTargetPeriodArgs) {
  return useQuery({
    queryKey: ['deductions', 'target-period', { date, gangId, targetWorkerId }],
    queryFn: ({ signal }) =>
      getDeductionTargetPeriod(
        {
          date: date!,
          gangId: gangId ?? undefined,
          targetWorkerId: targetWorkerId ?? undefined,
        },
        signal
      ),
    enabled: !!date,
    staleTime: 60_000,
  });
}
